import React from 'react'
import { Container } from './components/Styled'

interface Props {
  title?: string
  slug?: string
}

export const MainTitle: React.FC<Props> = ({ title }) => {
  return (
    <Container>
      <h1>{title}</h1>
      <div className='featured-section'>
        <h4>
          Articles are great, but nothing beats connecting with others.
        </h4>
        <a
          href='https://www.facebook.com/groups/sofiaandgrace'
          target='_blank'
          rel='noopener noreferrer'
        >
          Join Our Private Group
        </a>
      </div>
    </Container>
  )
}
